import { render, staticRenderFns } from "./view-update-argue.vue?vue&type=template&id=274052c1&scoped=true&lang=pug"
import script from "./view-update-argue.vue?vue&type=script&lang=js"
export * from "./view-update-argue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274052c1",
  null
  
)

export default component.exports